
<template>
    <Datepicker
        class="yt-date"
        type="text"
        v-model="value"
        input-class="form-control"
        :calendar-button="true"
        calendar-button-icon="fas fa-calendar-alt"
        :clear-button="true"
        clear-button-icon="fas fa-times"
        :disabled="disabled"
        :maxlength="schema.max"
        :placeholder="schema.placeholder"
        :readonly="schema.readonly" />
</template>

<script>
import { abstractField } from 'vue-form-generator'
import Datepicker from 'vuejs-datepicker'

export default {
    mixins: [ abstractField ],
    components: {
        Datepicker
    },
    computed: {
        maxYear () {
            return `${new Date().getFullYear() + 1}`
        }
    }
}
</script>

<style lang="scss" scoped>
.yt-date {
    width: 100%;

    /deep/ {
        .vdp-datepicker__calendar-button {
            position: absolute;
            right: 10px;
            top: 8px;
        }

        .vdp-datepicker__clear-button {
            position: absolute;
            right: 34px;
            top: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/FieldDate.vue